export function partition<T>(list : Iterable<T>, filterFn : (item: T)=>boolean) {
  const yes = [], no = [];
  for(const item of list){
    if(filterFn(item)) yes.push(item);
    else no.push(item);
  }
  return [yes, no]
}

export function* chunkWhile<T>(list : Iterable<T>, criteriaFn : (last: T, item: T)=>boolean) {
  let group : T[] = []
  for(const item of list) {
    if(!group.length || criteriaFn(group[group.length - 1], item)) {
      group.push(item)
    } else {
      yield group
      group = [item]
    }
  }
  if(group.length) yield group;
}

export function tally<T>(list : Iterable<T>) {
  let memo = new Map<T, number>();
  for(const item of list) {
    memo.set(item, (memo.get(item) || 0) + 1);
  }
  return memo
}

export function* eachCons<T, R = T[]>(list : Iterable<T>, size = 2, fn : (window: T[])=>R = (window => window as R)) {
  const window : T[] = []
  for(const item of list) {
    window.push(item)
    if(window.length > size) window.shift();
    if(window.length == size) yield fn([...window]);
  }
}
